import { Box, Paper, Skeleton } from '@mui/material';

export default function PageLoader({ containerStyle }: { containerStyle?: React.CSSProperties } = {}) {
	return (
		<Box style={{ ...containerStyle, height: '100vh' }}>
			<Paper elevation={3} style={{ padding: '16px' }}>
				<Skeleton variant="text" style={{ marginTop: '16px' }} />
				<Skeleton variant="rectangular" width="100%" height={200} style={{ marginTop: '16px' }} />
				<Skeleton variant="text" width="60%" style={{ marginTop: '16px' }} />
				<Skeleton variant="text" width="35%" style={{ marginTop: '8px' }} />
				<Skeleton variant="rectangular" width="100%" height={200} style={{ marginTop: '16px' }} />
				<Skeleton variant="text" style={{ marginTop: '16px' }} />
			</Paper>
		</Box>
	);
}
